export const unitsOnRentKeys = {
    all: ['units-on-rent'] as const,
    forJob: (jobId: string, rentalAssetTypeId: string) =>
        [...unitsOnRentKeys.all, jobId, rentalAssetTypeId] as const,
}
